import f from '@/application/shared/functions'
class Autoupdater {
	constructor(core){
        this.core = core
	}

    checkNewVersion (){
        return this.core.api.autoupdater.getLatest().then((d) => {

            if(!d.prerelease && f.numfromreleasestring(d.name) > f.numfromreleasestring(this.core.package.version)){

                var asset = _.find(d.assets || [], (asset) => {
                    return asset.name == this.core.apkAutoUpdaterName
                })

                if (asset){
                    return Promise.resolve(asset)
                }

                
            }

            return Promise.reject()
        })
    }

    checkAvailable (){
        if (window.plugins && window.ApkUpdater) {

            return Promise.resolve()

        }
        else {

            return Promise.reject('empty')
        }
    }

    hasupdates (){
        return this.checkAvailable().then(() => {
            return this.checkNewVersion()
        }).then((upd) => {
            this.core.store.commit('update', upd)
        }).catch(e => {

        })
    }

    downloadAndInstall(update) {

        return this.download(update).then(r => {

            this.core.store.commit('updating', {update, installing : true})

            return window.ApkUpdater.install()

        }).then(r => {
            this.core.store.commit('update', null)

            return Promise.resolve()
        }).catch(e => {

            console.error(e)

            return Promise.reject(e)
        }).finally(() => {
            this.core.store.commit('updating', null)
        })

    }

    download (update) {
        console.log('update', update)
        return window.ApkUpdater.download(update.browser_download_url, {
            onDownloadProgress:  (e) => {
                this.core.store.commit('updating', {update, progress : e.progress})
            }
        }).then(r => {
            this.core.store.commit('updating', null)

            return Promise.resolve()
        }).catch(e => {
            this.core.store.commit('updating', null)

            console.error(e)

            try {
                e = JSON.stringify(e)
            } catch (er) {

            }

            return Promise.reject(e)
        })


    }


}


export default Autoupdater


